import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    console.error("💥 ERROR BOUNDARY CAUGHT:", error);
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("💥 ERROR DETAILS:", error);
    console.error("💥 ERROR INFO:", errorInfo);
    this.setState({ error, errorInfo });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-900 p-4">
          <div className="bg-slate-800/60 backdrop-blur-sm p-8 rounded-lg text-center max-w-2xl">
            <h2 className="text-2xl font-bold text-white mb-4">
              ❌ Erreur détectée
            </h2>
            <p className="text-gray-300 mb-6">
              {this.state.error?.message || "Erreur inconnue"}
            </p>
            <pre className="bg-black text-red-400 p-4 rounded mb-6 text-left text-sm overflow-auto max-h-64">
              {this.state.error?.stack}
            </pre>
            <button 
              onClick={() => window.location.reload()}
              className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg transition-colors"
            >
              Rafraîchir la page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;